import type { UiLocale } from '@/i18n/schema'

/**
 * 从 Vue Router 的 `path`（相对 `base`，不含 `/editor` 前缀）解析 UI 语种。
 *
 * @param routerPath - 例如 `/`、`/zh-CN`、`/ja`
 */
export function editorPathToUiLocale(routerPath: string): UiLocale {
  const normalized = (routerPath.replace(/\/+$/, '') || '/').split('?')[0] || '/'
  if (normalized === '/zh-CN' || normalized.startsWith('/zh-CN/')) return 'zh-CN'
  if (normalized === '/ja' || normalized.startsWith('/ja/')) return 'ja-JP'
  return 'en-US'
}

/**
 * UI 语种 → 编辑器内路由 path（相对 Vite `base`）。
 */
export function uiLocaleToEditorRouterPath(ui: UiLocale): '/' | '/zh-CN' | '/ja' {
  if (ui === 'zh-CN') return '/zh-CN'
  if (ui === 'ja-JP') return '/ja'
  return '/'
}

/**
 * 与营销站 `prefix_except_default` 一致：英语无前缀，`zh-CN`/`ja` 带前缀。
 *
 * @param marketingPath - 以 `/` 开头的营销站内路径，如 `/`、`/consult`
 * @param ui - 编辑器当前 UI 语种
 */
export function marketingPathForEditorUiLocale(marketingPath: string, ui: UiLocale): string {
  const p = marketingPath.startsWith('/') ? marketingPath : `/${marketingPath}`
  if (ui === 'zh-CN') {
    if (p === '/') return '/zh-CN'
    return `/zh-CN${p}`
  }
  if (ui === 'ja-JP') {
    if (p === '/') return '/ja'
    return `/ja${p}`
  }
  if (p === '/') return '/'
  return p
}

/**
 * 供 `document.documentElement.lang` 与 `<html lang>` 对齐。
 */
export function editorDocumentLangForUiLocale(ui: UiLocale): string {
  if (ui === 'zh-CN') return 'zh-CN'
  if (ui === 'ja-JP') return 'ja-JP'
  return 'en-US'
}
